export default "__VITE_ASSET__b893cb24__"